module.exports = __webpack_public_path__ + "img/source_book-item10.4daa3724.png";